import React, { useState } from 'react'
import { useEffect } from 'react';
import { getDefaultName, userAvatar } from '../utils';
import { loadTalent, loadUserTalent } from '../utils/Network';

export default function ModalPeopleDegreeProgress({ degree_item , index}) {

    useEffect(() => {
    }, [])

    
    function BadgeClass(){
        
        if (degree_item.degree <3){
          
            return "badge bg-red mt-14";
        }
        else if (degree_item.degree  <6) {
            return "badge bg-yellow mt-14";
        }
        else if (degree_item.degree  < 8) {
            return "badge bg-light-blue mt-14";
        }
        else if (degree_item.degree  <=10) {
            return "badge bg-green mt-14";
        }

        
    }

    const ProgressClass=()=>{
        if (degree_item.degree  < 3) {

            return "progress-bar progress-bar-danger";
        }
        else if (degree_item.degree  < 6) {
            return "progress-bar progress-bar-yellow";
        }
        else if (degree_item.degree  < 8) {
            return "progress-bar progress-bar-primary";
        }
        else if (degree_item.degree  <= 10) {
            return "progress-bar  progress-bar-success";
        }
        
    }

    
    
    return (
        <tr key={degree_item.id} >
            <td>{index+1}</td>
            <td>
                
                <img src={userAvatar(degree_item.user.profile)} alt={degree_item.user?.profile?.first_name+" " + degree_item.user?.profile?.last_name} className="pull-left mr-5 img-circle width-20" />
                <p className="pull-left" title={degree_item.user?.profile?.first_name+" " + degree_item.user?.profile?.last_name}>
                    {degree_item.user.email} 
                     <br/>

                    {degree_item.user.last_login.split('T')[0]}<br/>
                    {degree_item.user.last_login.split('T')[1]}
                </p>
            </td>
            <td style={{  width:200 }}>
                <small>{degree_item.degree}</small>
                <div className="progress progress-xs progress-striped">
                    <div className={ProgressClass()} style={{ width: (degree_item.degree*10)+"%" }}></div>
                </div>
            </td>
            <td >
                <span className={BadgeClass()}>{degree_item.degree} </span>
            </td>
        </tr>
    )
}
